import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const onCallDeleteService = createAsyncThunk(
  "schedule/onCallDeleteService",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.serviceDelete(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });
    return response;
  }
);

export const onCallDeleteServiceSlice = createSlice({
  name: "onCallDeleteService",
  initialState,
  reducers: {
    clearOnCallDeleteServiceResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(onCallDeleteService.pending, (state) => {
        state.loading = true;
      })
      .addCase(onCallDeleteService.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(onCallDeleteService.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const onCallDeleteServiceList = (state) => state.onCallDeleteService.value;
export const onCallDeleteServiceLoading = (state) => state.onCallDeleteService.loading;
export const {clearOnCallDeleteServiceResponse} = onCallDeleteServiceSlice.actions;

export default onCallDeleteServiceSlice.reducer;
